import React, { useCallback, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import HeroSection from '../components/HeroSection';
import AboutSection from '../components/AboutSection';
import ServicesSection from '../components/ServicesSection';
import PricingSection from '../components/PricingSection';
import ScheduleSection from '../components/ScheduleSection';
import TestimonialsSection from '../components/TestimonialsSection';
import AppointmentSection from '../components/AppointmentSection';
import TelegramBlogSection from '../components/TelegramBlogSection';
import FAQSection from '../components/FAQSection';

const HomePage = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const scrollToAppointment = useCallback(() => {
    const element = document.querySelector('#appointment');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }, []);

  const scrollToBooking = (serviceValue) => {
    if (serviceValue) {
      setSearchParams({ service: serviceValue }, { replace: true });
      return;
    }
    scrollToAppointment();
  };

  useEffect(() => {
    if (searchParams.get('service')) {
      const timer = window.setTimeout(scrollToAppointment, 0);
      return () => window.clearTimeout(timer);
    }
    return undefined;
  }, [searchParams, scrollToAppointment]);

  return (
    <div>
      <HeroSection onBookingClick={scrollToBooking} />
      <AboutSection onBookingClick={scrollToBooking} />
      <ServicesSection onBookingClick={scrollToBooking} />
      <PricingSection onBookingClick={scrollToBooking} />
      <ScheduleSection />
      <TestimonialsSection />
      <AppointmentSection />
      <TelegramBlogSection />
      <FAQSection />
    </div>
  );
};

export default HomePage;
